import NamespacedSerializer from '@linc-technologies/linced-common/serializers/namespaced';

// Base maps `enrolments/x` model names to the `x` payload keys of the
// enrolments service.
export default class Base extends NamespacedSerializer {
  namespace = 'enrolments';
}
